import { IntegrityMonitorAssignRulesFormView } from '../view/IntegrityMonitorAssignRulesFormView';
import { templateIntegrityMonitorAssignRulesForm } from '../view/template';
import { IntegrityMonitorAssignRulesFormRepository } from '../repository/IntegrityMonitorAssignRulesFormRepository';
import { BaseWebComponentController } from '../../../../framework/BaseWebComponentController';
import { IntegrityMonitorAssignRulesFormWebComponent } from '..';
import { AssignRulesFormEvents, IntegrityMonitorAssignRulesFormWebComponentSchema } from '../types';
import { EnumListEvents } from '../../../../ui/gzEnumList/types';
import { showErrorToast, showSuccessToast } from '@nirvana/shared/common';

export class IntegrityMonitorAssignRulesFormController extends BaseWebComponentController {
  public component: IntegrityMonitorAssignRulesFormWebComponent;
  public dataRepository: IntegrityMonitorAssignRulesFormRepository;
  public view: IntegrityMonitorAssignRulesFormView;
  public viewConstructor: typeof IntegrityMonitorAssignRulesFormView;
  public dataRepositoryConstructor: typeof IntegrityMonitorAssignRulesFormRepository;

  constructor(component: IntegrityMonitorAssignRulesFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrityMonitorAssignRulesFormView,
      viewTemplate: templateIntegrityMonitorAssignRulesForm,
      dataRepositoryConstructor: IntegrityMonitorAssignRulesFormRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$ruleSetsSelector,
        event: EnumListEvents.SELECTION_CHANGE,
        callback: this.onRuleSetsSelectionChange,
      },
      {
        element: this.view.dom.$assignButton,
        event: 'click',
        callback: this.assignRulesToSelectedRuleSets,
      },
      {
        element: this.view.dom.$cancelButton,
        event: 'click',
        callback: this.closeAssignRulesForm,
      },
    ];
  }

  async getDataForView(): Promise<IntegrityMonitorAssignRulesFormWebComponentSchema> {
    return {
      ruleSetOptions: this.component.ruleSetOptions ?? [],
    };
  }

  private onRuleSetsSelectionChange(event: CustomEvent) {
    const ruleSetIds = event.detail.selectedValues;
    this.component.selectedRuleSetIds = ruleSetIds;
    this.view.setDisabledAssignButton(ruleSetIds.length === 0);
  }

  private async assignRulesToSelectedRuleSets() {
    this.view.dom.$assignButton.showSpinner = true;
    this.view.dom.$assignButton.disabled = true;

    try {
      await this.dataRepository.assignRulesToRuleSets(
        this.dependencies.getActiveCompany().companyId,
        this.component.ruleIds ?? [],
        this.component.selectedRuleSetIds ?? []
      );

      showSuccessToast(this.dependencies.translateFn('Rules assigned successfully.'));

      this.closeAssignRulesForm();

      // Notify the grid for data reloading
      this.component.dispatchEvent(
        new CustomEvent(AssignRulesFormEvents.ASSIGNED_RULES, {
          bubbles: true,
        })
      );
    } catch (error) {
      // if the exception is AuthenticationSecurityException it is already treated by the general session exception
      if (error?.exceptionType === 'Exceptions\\AuthenticationSecurityException') {
        return;
      }

      showErrorToast(error);
    } finally {
      // remove the spinner
      this.view.dom.$assignButton.showSpinner = false;
    }
  }

  private closeAssignRulesForm() {
    this.component.isVisible = false;
    this.component.ruleIds = undefined;
    this.component.selectedRuleSetIds = undefined;
    this.component.ruleSetOptions = undefined;
    this.view.setDisabledAssignButton(true);
  }
}
